module.exports = __webpack_public_path__ + "static/gallery-17-156cd555ffde935f42674dae48a57244.jpeg";